import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import moment from 'moment'
import config from '../../config';
// import getDSFPerson from '../../lib/dsf-client';


function getDSFPerson(data) {
  console.log('getDSFPerson', data)
  const { ssn, firstName, lastName } = data

  const submitData = {
    ssn: ssn,
    firstname: firstName,
    lastname: lastName,
    foo: 'barX13+1',
  }

  if (!ssn || ssn.length < 10 || !firstName || firstName.length < 1 || !lastName || lastName.length < 1) {
    throw new Error('Både personnummer, fornavn og etternavn må oppgis for å kunne utføre kontroll mot folkeregisteret.')
  } else {
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()

    return axios.post(`${config.apiUrl}/get_dsf_person`, submitData, { cancelToken: source.token })
      // axios.post(`${config.apiUrl}/get_person`, submitData)
      .then(r => {
        console.log('responseData', r.data.data)
        // XXX: The return value appears to be different in test and prod, hence all the logic below
        const responseData = (r.data && r.data.data) ? r.data.data : null
        // const deepData = data.data && data.data[0] ? data.data[0] : {ssn: data.dateOfBirth.replace(/-/g, '')}
        const address = typeof responseData.address === 'string' ? { street: responseData.address, zipCode: responseData.postalCode, city: responseData.postalArea } : (responseData.address || {})
        const hasAllRequired = responseData.firstName && responseData.lastName && address.street && address.zipCode && address.city
        const person = {
          verified: hasAllRequired,
          partlyVerified: !hasAllRequired,
          firstName: responseData.firstName + (responseData.middleName ? ` ${responseData.middleName}` : ''),
          lastName: responseData.lastName,
          email: data.email,
          ssn: submitData.ssn,
          address: address.street,
          postalCode: address.zipCode,
          postalArea: address.city,
          // dateOfBirth: moment.utc(deepData.ssn, 'YYYYMMDD').toISOString()
          dateOfBirth: moment.utc(responseData.dateOfBirth, 'YYYY-MM-DD').toISOString()
        }
        console.log('person', person)
        return {
          success: r.data.success,
          person
        }
      })
      .catch(e => {
        console.log('e', e)
        if (axios.isCancel(e)) {
          throw new Error('Kunne ikke slå opp personen i folkeregisteret innen rimelig tid.')
        } else {
          if (e && e.response && e.response.data && e.response.data.errorCode === 'personNotFound') {
            throw new Error('Personen ble ikke funnet i folkeregisteret.')
          } else {
            throw new Error('Det oppsto en feil - Prøv på nytt eller kontakt teamleader')
          }
        }
      })
  }
}

const DeferredOrderDetails = ({ id, onBack }) => {
  const [order, setOrder] = useState(null);
  const [dsfResult, setDsfResult] = useState(null);
  const [finalizeResult, setFinalizeResult] = useState(null);
  const [finalizing, setFinalizing] = useState(false);
  const [loading, setLoading] = useState(true); // loading order
  const [dsfLoading, setDsfLoading] = useState(false); // loading DSF lookup
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    axios.get(`${config.newApiUrl}/orders/deferred/${id}`)
      .then(r => {
        setOrder(r.data.data);
        setLoading(false);
      })
      .catch(e => {
        setError('Kunne ikke hente ordren');
        setLoading(false);
      });
  }, [id]);

  // Mock API for finalizing order
  const finalizeDeferredOrder = async (orderId, data) => {
    setFinalizing(true);
    setError(null);
    axios.post(`${config.newApiUrl}/orders/deferred/${id}/finalize`, {
      first_name: dsfResult?.person?.firstName,
      last_name: dsfResult?.person?.lastName,
      address: dsfResult?.person?.address,
      postal_code: dsfResult?.person?.postalCode,
      postal_area: dsfResult?.person?.postalArea,
    })
      .then(r => {
        console.log('finalizeDeferredOrder', r.data.data, r.status)
        if (r.status === 200) {
          setFinalizeResult(r.data.data);
        } else {
          setError('Kunne ikke fullføre ordren');
        }
        setFinalizing(false);
      })
      .catch(e => {
        console.log('finalizeDeferredOrder error', e)
        setError('Kunne ikke fullføre ordren');
        setFinalizing(false);
      });
  };

  const handleLookup = async (owner) => {
    setDsfLoading(true);
    setError(null);
    try {
      const result = await getDSFPerson({
        ssn: owner.ssn,
        firstName: owner.first_name,
        lastName: owner.last_name,
        email: owner.email,
      });
      setDsfResult(result);
    } catch (e) {
      setError('FREG-oppslag feilet');
    }
    setDsfLoading(false);
  };

  let orderOwner = order?.items?.find(item => item.is_owner);
  if (!orderOwner) {
    orderOwner = (order?.items || [])[0]
  }

  // TEMPORARY: Mock FREG/DSF data for visual testing
  // useEffect(() => {
  //   if (!dsfResult && orderOwner) {
  //     setDsfResult({
  //       found: true,
  //       firstName: orderOwner.first_name, // identical
  //       lastName: 'Nyttetternavn',        // different
  //       address: 'Nyveien 456',           // different
  //       postalCode: '9999',               // different
  //       postalArea: orderOwner.postal_area, // identical
  //     });
  //   }
  //   // Remove this after visual check!
  // }, [dsfResult, orderOwner]);

  if (loading) return <div className="deferred-details__loading">Laster salgsdata...</div>;
  if (!order) return null;

  // Define the fields to display and compare
  const fields = [
    {
      key: 'name',
      label: 'Navn',
      current: `${orderOwner.first_name} ${orderOwner.last_name}`,
      newValue: dsfResult?.success ? `${dsfResult.person.firstName} ${dsfResult.person.lastName}` : null,
    },
    {
      key: 'address',
      label: 'Adresse',
      current: orderOwner.address,
      newValue: dsfResult?.success ? dsfResult.person.address : null,
    },
    {
      key: 'postalCode',
      label: 'Postnummer',
      current: orderOwner.postal_code,
      newValue: dsfResult?.success ? dsfResult.person.postalCode : null,
    },
    {
      key: 'postalArea',
      label: 'Poststed',
      current: orderOwner.postal_area,
      newValue: dsfResult?.success ? dsfResult.person.postalArea : null,
    },
  ];

  return (
    <div className="deferred-details__main-wrapper" style={{ maxWidth: 1100, margin: '2rem auto', display: 'flex', gap: 40, alignItems: 'flex-start' }}>
      {/* Details/compare box  */}
      <div className="deferred-details__container" style={{ width: 500, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', padding: '2rem' }}>
        {onBack && (
          <a
            href="#"
            className="deferred-details__back-link"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              textDecoration: 'none',
              color: '#1766b3',
              fontWeight: 600,
              marginBottom: 16,
              fontSize: 15
            }}
            onClick={e => { e.preventDefault(); onBack && onBack(); }}
          >
            <span style={{ fontSize: 18, display: 'inline-block', transform: 'translateY(1px)' }}>←</span>
            Tilbake til liste
          </a>
        )}
        {/* <h2 style={{ marginBottom: 24 }}>Detaljer for ufullstendig salg</h2> */}
        <div className="deferred-details__fields" style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {fields.map(field => (
            <div
              key={field.key}
              className="deferred-details__field"
              style={{ padding: 12, borderRadius: 6, background: '#f6f8fa', marginBottom: 0 }}
            >
              <div className="deferred-details__field-label" style={{ fontWeight: 600, marginBottom: 6 }}>{field.label}</div>
              <div className="deferred-details__value deferred-details__value--current" style={{ background: '#e0e0e0', padding: '6px 12px', borderRadius: 4, marginBottom: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: '#222' }}>{field.current || <span style={{ color: '#aaa' }}>-</span>}</span>
                <span style={{ fontSize: 13, fontWeight: 500, color: '#444', marginLeft: 12, minWidth: 80, textAlign: 'right' }}>Registrert</span>
              </div>
              {/* FREG row always shown, with different states */}
              {(!dsfResult || dsfLoading) ? (
                <div className="deferred-details__value deferred-details__value--pending" style={{ background: '#f0f0f0', padding: '6px 12px', borderRadius: 4, fontStyle: 'italic', color: '#888', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: '#888' }}>Venter på oppslag.</span>
                  <span style={{ fontSize: 13, fontWeight: 500, color: '#888', marginLeft: 12, minWidth: 80, textAlign: 'right', fontStyle: 'normal' }}>FREG</span>
                </div>
              ) : field.newValue && field.newValue !== field.current ? (
                <div className="deferred-details__value deferred-details__value--new" style={{ background: '#ffe9cc', padding: '6px 12px', borderRadius: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: '#b85b00' }}>{field.newValue}</span>
                  <span style={{ fontSize: 13, fontWeight: 500, color: '#e65100', marginLeft: 12, minWidth: 80, textAlign: 'right' }}>FREG</span>
                </div>
              ) : field.newValue && field.newValue === field.current ? (
                <div className="deferred-details__value deferred-details__value--identical" style={{ background: '#e8f5e9', padding: '6px 12px', borderRadius: 4, color: '#4caf50', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>{field.newValue}</span>
                  <span style={{ fontSize: 13, fontWeight: 500, color: '#388e3c', marginLeft: 12, minWidth: 80, textAlign: 'right' }}>FREG (samme)</span>
                </div>
              ) : null}
            </div>
          ))}
        </div>
        {error && (
          <div
            className="deferred-details__error"
            style={{ background: '#ffeaea', color: '#b71c1c', border: '1px solid #ffbdbd', borderRadius: 4, padding: '10px 16px', margin: '20px 0 0 0', fontWeight: 500 }}
          >
            {error}
          </div>
        )}
        {dsfResult && !dsfResult.success && (
          <div style={{ marginTop: 16, color: '#b71c1c', fontWeight: 500 }}>
            Fant ingen FREG-data for dette fødselsnummeret.
          </div>
        )}
        {finalizeResult && (
          <div style={{ marginTop: 16, color: '#388e3c', fontWeight: 600 }}>
            Salg fullført!
          </div>
        )}
        <div style={{ display: 'flex', gap: 12, marginTop: 28, alignItems: 'center' }}>
          {!dsfResult && (
            <button
              type="button"
              className="deferred-details__lookup-btn"
              style={{ padding: '10px 20px', background: '#8dc63f', color: '#fff', border: 'none', borderRadius: 4, fontWeight: 600, cursor: dsfLoading ? 'not-allowed' : 'pointer', opacity: dsfLoading ? 0.7 : 1 }}
              onClick={() => handleLookup(orderOwner)}
              disabled={dsfLoading}
            >
              Slå opp i FREG
            </button>
          )}
          {dsfLoading && (
            <span
              className="deferred-details__dsf-loading"
              style={{ background: '#f6f8fa', color: '#1766b3', borderRadius: 4, padding: '8px 14px', fontWeight: 500, fontSize: 14 }}
            >
              Slår opp i FREG...
            </span>
          )}
          {finalizing && (
            <span
              className="deferred-details__dsf-loading"
              style={{ background: '#f6f8fa', color: '#1766b3', borderRadius: 4, padding: '8px 14px', fontWeight: 500, fontSize: 14 }}
            >
              Fullfører salg...
            </span>
          )}
          {dsfResult?.success && !finalizeResult && (
            <button
              type="button"
              className="deferred-details__finalize-btn"
              style={{ padding: '10px 20px', background: '#1766b3', color: '#fff', border: 'none', borderRadius: 4, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
              onClick={() => finalizeDeferredOrder(id, dsfResult)}
              disabled={loading}
            >
              Fullfør salg
            </button>
          )}
        </div>
      </div>

      {/* Order summary */}
      <div className="deferred-details__summary-card" style={{ width: 440, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', padding: '2rem', display: 'flex', flexDirection: 'column', gap: 18 }}>
        <h2 style={{ marginBottom: 24 }}>Detaljer for ufullstendig salg</h2>
        <div style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 14, color: '#888', marginBottom: 2 }}>Opprettet:</div>
          <div style={{ fontWeight: 600, fontSize: 16 }}>{order.created_at}</div>
        </div>
        <div>
          <div style={{ fontSize: 14, color: '#888', marginBottom: 2 }}>Selger:</div>
          <div style={{ fontWeight: 600, fontSize: 16 }}>{order.user.first_name} {order.user.last_name}</div>
        </div>
        <div>
          <div style={{ fontSize: 14, color: '#888', marginBottom: 2 }}>Byrå:</div>
          <div style={{ fontWeight: 600, fontSize: 16 }}>{order.department.name}</div>
        </div>
        <div style={{ margin: '14px 0 0 0' }}>
          <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 2 }}>Ordrelinjer</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {order.items.map(item => (
              <div style={{ padding: '10px 0', borderBottom: '1px solid #eee' }}>
                <div style={{ fontWeight: 500, fontSize: 15, marginBottom: 2 }}>{item.first_name} {item.last_name}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 2, marginLeft: 8 }}>
                  <div style={{ fontSize: 14 }}>{item.subscription.name} <span style={{ color: '#999' }}>— {item.subscription.amount} kr/mnd</span></div>
                  {item.product_options.map(product_option => (
                    <div style={{ fontSize: 14 }}>{product_option.name} <span style={{ color: '#999' }}>— {product_option.amount} kr/mnd</span></div>
                  ))}
                  {item.campaigns.map(campaign => (
                    <div style={{ fontSize: 14 }}>{campaign.name}</div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

DeferredOrderDetails.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onBack: PropTypes.func,
};

export default DeferredOrderDetails;
